import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";

import makeApiRequest from "../../utils/axios/new-axios";
import { ACL_DELETE_ROLE_URL } from "../../config";
import SubmitButton from "../button/SubmitButton";
import CancelButton from "../button/CancelButton";
import TextField from "../formik/TextField";
import {
    showSuccessAlert,
    showErrorAlert
} from "../../store/actions/alerts";

import history from "../../store/history";

const useStyles = makeStyles(theme => ({
    form: {
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        width: "fit-content"
    }
}));

const yupSchema = Yup.object().shape({
    roleName: Yup.string()
        .trim()
        .required("Category Name Required!")
});

export default function DeleteRoleForm({
    openModal,
    handleCloseModal,
    roleId,
    roleName,
}) {
    const dispatch = useDispatch();
    const classes = useStyles();

    async function handleSubmit(values, { setSubmitting }) {
        setSubmitting(true);
        if (values.roleName === roleName) {
            await makeApiRequest({
                url: `${ACL_DELETE_ROLE_URL.url}/${roleId}`,
                method: ACL_DELETE_ROLE_URL.method
            })
                .then(response => {
                    dispatch(showSuccessAlert(`Deleted ${roleName} Successfully!`));
                    history.push(`/acl/roles`);
                })
                .catch(error => {
                    dispatch(
                        showErrorAlert(
                            "Error : " +
                            (!!error.response
                                ? `${error.response.status}! - ${error.response.data.errorMessage}`
                                : error.message)
                        )
                    );
                });
        } else {
            dispatch(showErrorAlert("Name Doesn't Match"));
        }
        setSubmitting(false);
    }

    return (
        <Dialog
            open={openModal}
            onClose={handleCloseModal}
            fullWidth={true}
            maxWidth="sm"
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
        >
            <DialogTitle id="alert-dialog-title">Delete Admin Role</DialogTitle>

            <Formik
                initialValues={{ roleName: "" }}
                onSubmit={handleSubmit}
                validationSchema={yupSchema}
            >
                {props => {
                    const { touched, errors, isSubmitting } = props;
                    return (
                        <Form className={classes.form}>
                            <DialogContent dividers>
                                <p>
                                    This process is irreversible. Please perform the below before
                                    proceeding
                                </p>
                                <ul>
                                    <li>Remove all the users attached to this role</li>
                                </ul>
                                <p>
                                    {`Enter the role name ( ${roleName} ) and press the Delete button`}
                                </p>
                                <Field
                                    component={TextField}
                                    name="roleName"
                                    margin="dense"
                                    label="Role Name *"
                                    fullWidth
                                    helperText={touched.roleName && errors.roleName && errors.roleName}
                                    error={!!touched.roleName && !!errors.roleName}
                                    disabled={isSubmitting}
                                    autoFocus
                                />
                            </DialogContent>
                            <DialogActions style={{ margin: "20px" }}>
                                <CancelButton
                                    onClick={handleCloseModal}
                                    disabled={isSubmitting}
                                >
                                    Cancel
                                </CancelButton>
                                <SubmitButton
                                    disabled={isSubmitting}
                                    isSubmitting={isSubmitting}
                                    autoFocus
                                >
                                    Delete
                                </SubmitButton>
                            </DialogActions>
                        </Form>
                    );
                }}
            </Formik>
        </Dialog>
    )
}
